var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-folder-open",
    "data-name": "Icon awesome-folder-open",
    d: "M59.656,28.26,52.111,41.192A6.666,6.666,0,0,1,46.353,44.5H4.69a2.5,2.5,0,0,1-2.159-3.76l7.544-12.933A6.667,6.667,0,0,1,15.833,24.5H57.5a2.5,2.5,0,0,1,2.159,3.76ZM15.833,21.167H50v-5a5,5,0,0,0-5-5H28.333L21.667,4.5H5a5,5,0,0,0-5,5V38.463L7.2,26.128A10.034,10.034,0,0,1,15.833,21.167Z",
    transform: "translate(0 -4.5)",
    fill: "#a1a1b3",
    opacity: 0.492
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.7c37b03db1cdc4f9a1b8077afd91804c.svg";
export { ForwardRef as ReactComponent };